import React from 'react';
import { X, Plus, Minus, ShoppingBag, ArrowRight } from 'lucide-react';
import { useCart } from '../context/CartContext';
export function CartDrawer() {
  const {
    items,
    isOpen,
    closeCart,
    subtotal,
    updateQuantity,
    removeItem
  } = useCart();
  return <>
      {/* Backdrop */}
      <div className={`fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={closeCart} data-id="element-17" />

      {/* Drawer */}
      <div role="dialog" aria-label="Winkelwagen" className={`fixed top-0 right-0 h-full w-full sm:w-[400px] bg-white z-[70] shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-18">
        {/* Header */}
        <div className="px-6 py-6 border-b border-gray-100 flex items-center justify-between" data-id="element-19">
          <div className="flex items-center gap-2" data-id="element-20">
            <ShoppingBag className="text-brand-dark" size={20} data-id="element-21" />
            <h2 className="font-serif font-bold text-xl text-brand-dark" data-id="element-22">
              Winkelwagen
            </h2>
            <span className="bg-brand-cream text-brand-dark text-xs font-bold px-2 py-1 rounded-full" data-id="element-23">
              {items.length}
            </span>
          </div>
          <button onClick={closeCart} aria-label="Sluit winkelwagen" className="p-2 hover:bg-brand-cream rounded-full transition-colors text-brand-gray hover:text-brand-dark" data-id="element-24">
            <X size={20} data-id="element-25" />
          </button>
        </div>

        {/* Items */}
        <div className="flex-1 overflow-y-auto p-6" data-id="element-26">
          {items.length === 0 ? <div className="h-full flex flex-col items-center justify-center text-brand-gray" data-id="element-27">
              <ShoppingBag size={48} className="mb-4 opacity-20" data-id="element-28" />
              <p data-id="element-29">Je winkelwagen is leeg.</p>
              <button onClick={closeCart} className="mt-6 text-brand-red font-medium hover:underline" data-id="element-30">
                Verder winkelen
              </button>
            </div> : <div className="space-y-6" data-id="element-31">
              {items.map(item => <div key={item.id} className="flex gap-4" data-id="element-32">
                  <div className="w-20 h-20 bg-brand-cream rounded-xl overflow-hidden flex-shrink-0" data-id="element-33">
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover" loading="lazy" data-id="element-34" />
                  </div>
                  <div className="flex-1 flex flex-col justify-between" data-id="element-35">
                    <div data-id="element-36">
                      <h3 className="font-medium text-brand-dark text-sm leading-tight mb-1" data-id="element-37">
                        {item.name}
                      </h3>
                      <p className="text-brand-gray text-sm" data-id="element-38">
                        €{item.price.toFixed(2)}
                      </p>
                    </div>
                    <div className="flex items-center justify-between mt-2" data-id="element-39">
                      <div className="flex items-center border border-gray-200 rounded-lg" data-id="element-40">
                        <button onClick={() => updateQuantity(item.id, item.quantity - 1)} aria-label="Aantal verlagen" className="p-1.5 text-brand-gray hover:text-brand-dark transition-colors" data-id="element-41">
                          <Minus size={14} data-id="element-42" />
                        </button>
                        <span className="w-8 text-center text-sm font-medium" data-id="element-43">
                          {item.quantity}
                        </span>
                        <button onClick={() => updateQuantity(item.id, item.quantity + 1)} aria-label="Aantal verhogen" className="p-1.5 text-brand-gray hover:text-brand-dark transition-colors" data-id="element-44">
                          <Plus size={14} data-id="element-45" />
                        </button>
                      </div>
                      <button onClick={() => removeItem(item.id)} className="text-brand-gray hover:text-brand-red text-sm underline transition-colors" data-id="element-46">
                        Verwijder
                      </button>
                    </div>
                  </div>
                </div>)}
            </div>}
        </div>

        {/* Footer */}
        {items.length > 0 && <div className="border-t border-gray-100 p-6 bg-gray-50" data-id="element-47">
            <div className="flex justify-between items-center mb-4" data-id="element-48">
              <span className="text-brand-gray" data-id="element-49">Subtotaal</span>
              <span className="font-serif font-bold text-xl text-brand-dark" data-id="element-50">
                €{subtotal.toFixed(2)}
              </span>
            </div>
            <p className="text-xs text-brand-gray mb-6 text-center" data-id="element-51">
              Verzendkosten worden berekend bij het afrekenen.
            </p>
            <button className="w-full bg-brand-red text-white py-4 rounded-xl font-medium hover:bg-brand-darkRed hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-52">
              Afrekenen
              <ArrowRight size={18} data-id="element-53" />
            </button>
          </div>}
      </div>
    </>;
}